module.exports = __webpack_public_path__ + "img/logo_white.e4f314b6.png";